import React from 'react'

import Script from 'dangerous-html/react'
import { Helmet } from 'react-helmet'

import Navigation from '../components/navigation'
import Footer from '../components/footer'
import './divisions-services.css'

const DivisionsServices = (props) => {
  return (
    <div className="divisions-services-container1">
      <Helmet>
        <title>Divisions-Services - Swift Luminous Porcupine</title>
        <meta
          property="og:title"
          content="Divisions-Services - Swift Luminous Porcupine"
        />
        <link
          rel="canonical"
          href="https://swift-luminous-porcupine-7pvu8b.teleporthq.app/divisions-services"
        />
      </Helmet>
      <Navigation></Navigation>
      <section className="stx-hero">
        <div className="stx-hero-media">
          <img
            alt="Stratix Group Construction Operations"
            src="https://images.pexels.com/photos/5511065/pexels-photo-5511065.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
            className="stx-hero-img"
          />
          <div className="stx-hero-overlay"></div>
        </div>
        <div className="stx-hero-content">
          <div className="stx-hero-text-wrapper">
            <h1 className="hero-title">Integrated Construction Excellence</h1>
            <p className="hero-subtitle">
              Stratix Group oversees a portfolio of specialized, licensed
              operating companies delivering skilled execution across the
              construction lifecycle.
            </p>
            <div className="stx-hero-actions">
              <a href="#divisions">
                <div className="btn-lg btn btn-primary">
                  <span>Explore Divisions</span>
                </div>
              </a>
              <a href="#">
                <div className="btn-outline btn-lg btn">
                  <span>Corporate Overview</span>
                </div>
              </a>
            </div>
            <div className="stx-hero-filter">
              <div className="stx-filter-group">
                <div className="stx-filter-icon">
                  <svg
                    fill="none"
                    width="20"
                    xmlns="http://www.w3.org/2000/svg"
                    height="20"
                    stroke="currentColor"
                    viewbox="0 0 24 24"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <circle r="8" cx="11" cy="11"></circle>
                    <path d="m21 21-4.3-4.3"></path>
                  </svg>
                </div>
                <input
                  type="text"
                  aria-label="Search divisions"
                  placeholder="Search by trade or license..."
                  className="stx-filter-input"
                />
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="stx-services">
        <div className="stx-container">
          <div className="stx-section-header">
            <h2 className="section-title">Core Capability Overview</h2>
            <p className="section-content">
              Our operating structure provides comprehensive coverage across key
              infrastructure and building sectors.
            </p>
          </div>
          <div className="stx-services-grid">
            <div className="stx-service-card">
              <div className="stx-service-icon">
                <svg
                  fill="none"
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  stroke="currentColor"
                  viewbox="0 0 24 24"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <rect x="4" y="2" rx="2" width="16" height="20"></rect>
                  <path d="M12 10h.01M12 14h.01M12 6h.01M16 10h.01M16 14h.01M16 6h.01M8 10h.01M8 14h.01M8 6h.01M9 22v-3a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v3"></path>
                </svg>
              </div>
              <h3 className="section-subtitle">General Construction</h3>
              <p className="section-content">
                Turnkey project management and execution for commercial and
                residential developments.
              </p>
            </div>
            <div className="stx-service-card">
              <div className="stx-service-icon">
                <svg
                  fill="none"
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  stroke="currentColor"
                  viewbox="0 0 24 24"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M7 10h3V7L6.5 3.5a6 6 0 0 1 8 8l6 6a2 2 0 0 1-3 3l-6-6a6 6 0 0 1-8-8z"></path>
                </svg>
              </div>
              <h3 className="section-subtitle">Roofing Systems</h3>
              <p className="section-content">
                Specialized installation and maintenance of industrial,
                commercial, and luxury residential roofing.
              </p>
            </div>
            <div className="stx-service-card">
              <div className="stx-service-icon">
                <svg
                  fill="none"
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  stroke="currentColor"
                  viewbox="0 0 24 24"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M3 12h5l4 8V4l4 8h5"></path>
                </svg>
              </div>
              <h3 className="section-subtitle">MEP Services</h3>
              <p className="section-content">
                Mechanical, electrical, and plumbing solutions delivered by
                licensed master tradespeople.
              </p>
            </div>
            <div className="stx-service-card">
              <div className="stx-service-icon">
                <svg
                  fill="none"
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  stroke="currentColor"
                  viewbox="0 0 24 24"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"></path>
                  <path d="m9 12 2 2 4-4"></path>
                </svg>
              </div>
              <h3 className="section-subtitle">Restoration</h3>
              <p className="section-content">
                Emergency response and structural restoration for
                insurance-related property losses.
              </p>
            </div>
            <div className="stx-service-card">
              <div className="stx-service-icon">
                <svg
                  fill="none"
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  stroke="currentColor"
                  viewbox="0 0 24 24"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M3 21h18M3 10h18M5 6l7-3l7 3M4 10v11m16-11v11M8 14v3m4-3v3m4-3v3"></path>
                </svg>
              </div>
              <h3 className="section-subtitle">Public Works</h3>
              <p className="section-content">
                Municipal and government infrastructure projects adhering to
                strict compliance standards.
              </p>
            </div>
            <div className="stx-service-card">
              <div className="stx-service-icon">
                <svg
                  fill="none"
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  stroke="currentColor"
                  viewbox="0 0 24 24"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M15.707 21.293a1 1 0 0 1-1.414 0l-1.586-1.586a1 1 0 0 1 0-1.414l5.586-5.586a1 1 0 0 1 1.414 0l1.586 1.586a1 1 0 0 1 0 1.414z"></path>
                  <path d="m18 13l-1.375-6.874a1 1 0 0 0-.746-.776L3.235 2.028a1 1 0 0 0-1.207 1.207L5.35 15.879a1 1 0 0 0 .776.746L13 18M2.3 2.3l7.286 7.286"></path>
                  <circle r="2" cx="11" cy="11"></circle>
                </svg>
              </div>
              <h3 className="section-subtitle">Specialty Trades</h3>
              <p className="section-content">
                High-precision masonry, steelwork, and interior finishes for
                complex architectural designs.
              </p>
            </div>
          </div>
        </div>
      </section>
      <section id="divisions" className="stx-divisions">
        <div className="stx-container">
          <div className="stx-section-header">
            <h2 className="section-title">Operating Companies</h2>
            <p className="section-content">
              Direct access to our licensed divisions and their specialized
              service platforms.
            </p>
          </div>
          <div className="stx-divisions-grid">
            <div className="stx-division-card">
              <div className="stx-division-header">
                <span className="stx-division-badge">GC Licensed</span>
                <h3 className="section-subtitle">Stratix Build Co.</h3>
              </div>
              <p className="section-content">
                Full-service general contracting for commercial interior
                build-outs and new developments.
              </p>
              <div className="stx-division-meta">
                <div className="stx-meta-item">
                  <svg
                    fill="none"
                    width="16"
                    xmlns="http://www.w3.org/2000/svg"
                    height="16"
                    stroke="currentColor"
                    viewbox="0 0 24 24"
                    strokeWidth="2"
                  >
                    <path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z"></path>
                    <circle r="3" cx="12" cy="10"></circle>
                  </svg>
                  <span>HQ: Houston, TX</span>
                </div>
              </div>
              <a href="#">
                <div className="btn btn-sm btn-secondary">
                  <span>Visit Division Site</span>
                </div>
              </a>
            </div>
            <div className="stx-division-card">
              <div className="stx-division-header">
                <span className="stx-division-badge">Master Electrician</span>
                <h3 className="section-subtitle">STX Power Systems</h3>
              </div>
              <p className="section-content">
                Industrial electrical infrastructure, grid connectivity, and
                smart building automation.
              </p>
              <div className="stx-division-meta">
                <div className="stx-meta-item">
                  <svg
                    fill="none"
                    width="16"
                    xmlns="http://www.w3.org/2000/svg"
                    height="16"
                    stroke="currentColor"
                    viewbox="0 0 24 24"
                    strokeWidth="2"
                  >
                    <path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z"></path>
                    <circle r="3" cx="12" cy="10"></circle>
                  </svg>
                  <span>HQ: Dallas, TX</span>
                </div>
              </div>
              <a href="#">
                <div className="btn btn-sm btn-secondary">
                  <span>Visit Division Site</span>
                </div>
              </a>
            </div>
            <div className="stx-division-card">
              <div className="stx-division-header">
                <span className="stx-division-badge">Restoration Cert.</span>
                <h3 className="section-subtitle">Stratix Recovery</h3>
              </div>
              <p className="section-content">
                Rapid response property restoration and climate-controlled
                mitigation services.
              </p>
              <div className="stx-division-meta">
                <div className="stx-meta-item">
                  <svg
                    fill="none"
                    width="16"
                    xmlns="http://www.w3.org/2000/svg"
                    height="16"
                    stroke="currentColor"
                    viewbox="0 0 24 24"
                    strokeWidth="2"
                  >
                    <path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z"></path>
                    <circle r="3" cx="12" cy="10"></circle>
                  </svg>
                  <span>HQ: Austin, TX</span>
                </div>
              </div>
              <a href="#">
                <div className="btn btn-sm btn-secondary">
                  <span>Visit Division Site</span>
                </div>
              </a>
            </div>
            <div className="stx-division-card">
              <div className="stx-division-header">
                <span className="stx-division-badge">Roofing Master</span>
                <h3 className="section-subtitle">Summit Roofing by STX</h3>
              </div>
              <p className="section-content">
                Commercial flat roofing and residential steep-slope systems with
                lifetime warranties.
              </p>
              <div className="stx-division-meta">
                <div className="stx-meta-item">
                  <svg
                    fill="none"
                    width="16"
                    xmlns="http://www.w3.org/2000/svg"
                    height="16"
                    stroke="currentColor"
                    viewbox="0 0 24 24"
                    strokeWidth="2"
                  >
                    <path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z"></path>
                    <circle r="3" cx="12" cy="10"></circle>
                  </svg>
                  <span>HQ: San Antonio, TX</span>
                </div>
              </div>
              <a href="#">
                <div className="btn btn-sm btn-secondary">
                  <span>Visit Division Site</span>
                </div>
              </a>
            </div>
            <div className="stx-division-card">
              <div className="stx-division-header">
                <span className="stx-division-badge">Municipal Bonded</span>
                <h3 className="section-subtitle">Stratix Civil</h3>
              </div>
              <p className="section-content">
                Heavy civil engineering and public infrastructure for municipal
                partners.
              </p>
              <div className="stx-division-meta">
                <div className="stx-meta-item">
                  <svg
                    fill="none"
                    width="16"
                    xmlns="http://www.w3.org/2000/svg"
                    height="16"
                    stroke="currentColor"
                    viewbox="0 0 24 24"
                    strokeWidth="2"
                  >
                    <path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z"></path>
                    <circle r="3" cx="12" cy="10"></circle>
                  </svg>
                  <span>HQ: Fort Worth, TX</span>
                </div>
              </div>
              <a href="#">
                <div className="btn btn-sm btn-secondary">
                  <span>Visit Division Site</span>
                </div>
              </a>
            </div>
            <div className="stx-division-card">
              <div className="stx-division-header">
                <span className="stx-division-badge">MEP Licensed</span>
                <h3 className="section-subtitle">STX Mechanical</h3>
              </div>
              <p className="section-content">
                Complex HVAC and plumbing systems for healthcare and laboratory
                environments.
              </p>
              <div className="stx-division-meta">
                <div className="stx-meta-item">
                  <svg
                    fill="none"
                    width="16"
                    xmlns="http://www.w3.org/2000/svg"
                    height="16"
                    stroke="currentColor"
                    viewbox="0 0 24 24"
                    strokeWidth="2"
                  >
                    <path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z"></path>
                    <circle r="3" cx="12" cy="10"></circle>
                  </svg>
                  <span>HQ: Houston, TX</span>
                </div>
              </div>
              <a href="#">
                <div className="btn btn-sm btn-secondary">
                  <span>Visit Division Site</span>
                </div>
              </a>
            </div>
          </div>
        </div>
      </section>
      <section className="stx-markets">
        <div className="stx-container">
          <div className="stx-section-header">
            <h2 className="section-title">Market Alignment</h2>
            <p className="section-content">
              We serve diverse sectors with specialized operating companies
              tailored to unique regulatory needs.
            </p>
          </div>
          <div className="stx-markets-grid">
            <div className="stx-market-item">
              <h3 className="section-subtitle">Commercial &amp; Industrial</h3>
              <p className="section-content">
                Strategic oversight for large-scale facilities, warehouses, and
                corporate office developments.
              </p>
              <ul className="stx-market-list">
                <li>
                  <span>Stratix Build Co.</span>
                </li>
                <li>
                  <span>STX Power Systems</span>
                </li>
                <li>
                  <span>STX Mechanical</span>
                </li>
              </ul>
            </div>
            <div className="stx-market-item">
              <h3 className="section-subtitle">Residential Properties</h3>
              <p className="section-content">
                High-end residential construction and specialized roofing for
                homeowners and developers.
              </p>
              <ul className="stx-market-list">
                <li>
                  <span>Summit Roofing</span>
                </li>
                <li>
                  <span>Stratix Build Co.</span>
                </li>
                <li>
                  <span>Stratix Recovery</span>
                </li>
              </ul>
            </div>
            <div className="stx-market-item">
              <h3 className="section-subtitle">Insurance &amp; Risk</h3>
              <p className="section-content">
                Dedicated support for adjusters and carriers in property loss
                and structural restoration.
              </p>
              <ul className="stx-market-list">
                <li>
                  <span>Stratix Recovery</span>
                </li>
                <li>
                  <span>Summit Roofing</span>
                </li>
                <li>
                  <span>STX Mechanical</span>
                </li>
              </ul>
            </div>
            <div className="stx-market-item">
              <h3 className="section-subtitle">Municipal &amp; Govt</h3>
              <p className="section-content">
                Bonded and compliant infrastructure delivery for local, state,
                and federal agencies.
              </p>
              <ul className="stx-market-list">
                <li>
                  <span>Stratix Civil</span>
                </li>
                <li>
                  <span>STX Power Systems</span>
                </li>
                <li>
                  <span>Stratix Build Co.</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>
      <section className="stx-compliance">
        <div className="stx-container">
          <div className="stx-section-header">
            <h2 className="section-title">Institutional Standards</h2>
            <p className="section-content">
              Corporate-level governance ensuring every division meets strict
              compliance and safety mandates.
            </p>
          </div>
          <div className="stx-stats-grid">
            <div className="stx-stat-card">
              <span className="stx-stat-value">$50M+</span>
              <h4 className="stx-stat-label">Bonding Capacity</h4>
            </div>
            <div className="stx-stat-card">
              <span className="stx-stat-value">A+</span>
              <h4 className="stx-stat-label">Insurance Rating</h4>
            </div>
            <div className="stx-stat-card">
              <span className="stx-stat-value">0.72</span>
              <h4 className="stx-stat-label">Safety EMR</h4>
            </div>
            <div className="stx-stat-card">
              <span className="stx-stat-value">100%</span>
              <h4 className="stx-stat-label">Licensed Status</h4>
            </div>
            <div className="stx-stat-card">
              <span className="stx-stat-value">24/7</span>
              <h4 className="stx-stat-label">Risk Monitoring</h4>
            </div>
            <div className="stx-stat-card">
              <span className="stx-stat-value">ISO</span>
              <h4 className="stx-stat-label">Certified Protocols</h4>
            </div>
          </div>
        </div>
      </section>
      <section className="stx-process">
        <div className="stx-container">
          <div className="stx-section-header">
            <h2 className="section-title">Governance &amp; Coordination</h2>
            <p className="section-content">
              How Stratix Group manages and facilitates seamless execution
              across its divisions.
            </p>
          </div>
          <div className="stx-steps-wrapper">
            <div className="stx-step">
              <div className="stx-step-number">
                <span>01</span>
              </div>
              <h3 className="section-subtitle">Central Intake</h3>
              <p className="section-content">
                Unified point of contact for project vetting and division
                routing.
              </p>
            </div>
            <div className="stx-step">
              <div className="stx-step-number">
                <span>02</span>
              </div>
              <h3 className="section-subtitle">Division Selection</h3>
              <p className="section-content">
                Matching project requirements with the appropriate licensed
                entity.
              </p>
            </div>
            <div className="stx-step">
              <div className="stx-step-number">
                <span>03</span>
              </div>
              <h3 className="section-subtitle">Corporate Oversight</h3>
              <p className="section-content">
                Ongoing safety, quality, and compliance monitoring by Group
                leadership.
              </p>
            </div>
            <div className="stx-step">
              <div className="stx-step-number">
                <span>04</span>
              </div>
              <h3 className="section-subtitle">Skilled Execution</h3>
              <p className="section-content">
                Final delivery by the specialized division under STX standards.
              </p>
            </div>
          </div>
        </div>
      </section>
      <section className="stx-case-studies">
        <div className="stx-container">
          <div className="stx-section-header">
            <h2 className="section-title">Capability in Action</h2>
            <p className="section-content">
              Recent performance highlights from across our operating companies.
            </p>
          </div>
          <div className="stx-case-grid">
            <div className="stx-case-card">
              <img
                alt="Commercial Industrial Project"
                src="https://images.pexels.com/photos/8014692/pexels-photo-8014692.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
                className="stx-case-img"
              />
              <div className="stx-case-content">
                <span className="stx-case-division">Stratix Build Co.</span>
                <h3 className="section-subtitle">Logistics Hub Expansion</h3>
                <p className="section-content">
                  Completed a 200k sq. ft. industrial expansion ahead of
                  schedule with zero safety incidents.
                </p>
                <a href="#">
                  <div className="btn btn-link">
                    <span>Full Case Study</span>
                  </div>
                </a>
              </div>
            </div>
            <div className="stx-case-card">
              <img
                alt="Municipal Infrastructure"
                src="https://images.pexels.com/photos/31865990/pexels-photo-31865990.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
                className="stx-case-img"
              />
              <div className="stx-case-content">
                <span className="stx-case-division">Stratix Civil</span>
                <h3 className="section-subtitle">Municipal Water Works</h3>
                <p className="section-content">
                  Critical infrastructure upgrade for major metropolitan area
                  involving complex civil engineering.
                </p>
                <a href="#">
                  <div className="btn btn-link">
                    <span>Full Case Study</span>
                  </div>
                </a>
              </div>
            </div>
            <div className="stx-case-card">
              <img
                alt="Roofing Project"
                src="https://images.pexels.com/photos/13464875/pexels-photo-13464875.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
                className="stx-case-img"
              />
              <div className="stx-case-content">
                <span className="stx-case-division">Summit Roofing</span>
                <h3 className="section-subtitle">Hospitality Re-Roof</h3>
                <p className="section-content">
                  Luxury resort roofing replacement using high-durability
                  sustainable materials.
                </p>
                <a href="#">
                  <div className="btn btn-link">
                    <span>Full Case Study</span>
                  </div>
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="stx-contact">
        <div className="stx-container">
          <div className="stx-contact-wrapper">
            <div className="stx-contact-info">
              <h2 className="section-title">
                Direct Procurement &amp; Inquiries
              </h2>
              <p className="section-content">
                Contact our corporate office for RFP routing, division
                referrals, or partnership inquiries. We provide dedicated
                channels for insurance adjusters and municipal buyers.
              </p>
              <div className="stx-contact-details">
                <div className="stx-contact-method">
                  <svg
                    fill="none"
                    width="20"
                    xmlns="http://www.w3.org/2000/svg"
                    height="20"
                    stroke="currentColor"
                    viewbox="0 0 24 24"
                    strokeWidth="2"
                  >
                    <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path>
                  </svg>
                  <span>800-STRATIX-GP</span>
                </div>
                <div className="stx-contact-method">
                  <svg
                    fill="none"
                    width="20"
                    xmlns="http://www.w3.org/2000/svg"
                    height="20"
                    stroke="currentColor"
                    viewbox="0 0 24 24"
                    strokeWidth="2"
                  >
                    <rect x="2" y="4" rx="2" width="20" height="16"></rect>
                    <path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7"></path>
                  </svg>
                  <span>ops@stratixgroup.com</span>
                </div>
              </div>
              <div className="stx-brand-reinforce">
                <span className="divisions---services-stx-shorthand">STX</span>
                <p className="section-content">Skilled • Trusted • Execution</p>
              </div>
            </div>
            <div className="stx-contact-form-card">
              <form
                action="#"
                method="POST"
                data-form-id="61aeddc1-3fd3-4078-a65e-8b759bb04b70"
                className="stx-form"
              >
                <div className="stx-form-group">
                  <label htmlFor="name" className="section-content">
                    Full Name
                  </label>
                  <input
                    type="text"
                    id="name"
                    name="true"
                    required="true"
                    data-form-field-id="name"
                    className="stx-input"
                  />
                </div>
                <div className="stx-form-group">
                  <label htmlFor="org" className="section-content">
                    Organization / Agency
                  </label>
                  <input
                    type="text"
                    id="org"
                    name="org"
                    required="true"
                    data-form-field-id="org"
                    className="stx-input"
                  />
                </div>
                <div className="stx-form-group">
                  <label htmlFor="email" className="section-content">
                    Professional Email
                  </label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    required="true"
                    data-form-field-id="email"
                    className="stx-input"
                  />
                </div>
                <div className="stx-form-group">
                  <label htmlFor="inquiry" className="section-content">
                    Inquiry Type
                  </label>
                  <select
                    id="inquiry"
                    name="inquiry"
                    data-form-field-id="inquiry"
                    className="stx-input"
                  >
                    <option value="general">General Inquiry</option>
                    <option value="rfp">RFP / Bid Request</option>
                    <option value="insurance">Insurance Adjuster</option>
                    <option value="procurement">Government Procurement</option>
                  </select>
                </div>
                <div className="stx-form-group">
                  <label htmlFor="message" className="section-content">
                    Message
                  </label>
                  <textarea
                    id="message"
                    name="message"
                    rows="4"
                    required="true"
                    data-form-field-id="message"
                    className="stx-input"
                  ></textarea>
                </div>
                <button
                  id="thq_button_Wbk8"
                  name="button"
                  type="submit"
                  data-form-field-id="thq_button_Wbk8"
                  className="btn-lg btn btn-primary"
                >
                  Submit Inquiry
                </button>
              </form>
            </div>
          </div>
        </div>
      </section>
      <div className="divisions-services-container2">
        <div className="divisions-services-container3">
          <Script
            html={`<script defer data-name="stx-interactions">
(function(){
  // Division Search Filter Functionality
  const filterInput = document.querySelector('.stx-filter-input');
  const divisionCards = document.querySelectorAll('.stx-division-card');

  if (filterInput) {
    filterInput.addEventListener('input', (e) => {
      const searchTerm = e.target.value.toLowerCase();
      
      divisionCards.forEach(card => {
        const text = card.textContent.toLowerCase();
        if (text.includes(searchTerm)) {
          card.style.display = 'flex';
        } else {
          card.style.display = 'none';
        }
      });
    });
  }

  // Simple reveal animation for cards
  const observerOptions = {
    threshold: 0.1
  };

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.style.opacity = '1';
        entry.target.style.transform = 'translateY(0)';
      }
    });
  }, observerOptions);

  const animatedElements = document.querySelectorAll('.stx-service-card, .stx-division-card, .stx-case-card');
  animatedElements.forEach(el => {
    el.style.opacity = '0';
    el.style.transform = 'translateY(20px)';
    el.style.transition = 'all 0.6s ease-out';
    observer.observe(el);
  });
})()
</script>`}
          ></Script>
        </div>
      </div>
      <Footer></Footer>
    </div>
  )
}

export default DivisionsServices
